@if (atgard) {
  <div class="map-popup-header flex">
    <div class="map-popup-title">
      {{atgard.namn}}
      <rask-planeringsstatus-indicator
        class="statusCircle"
        [planeringsstatus]="atgard.planeringsstatus">
      </rask-planeringsstatus-indicator>
    </div>
    <div class="map-popup-beteckning">
      <div>
        {{atgard.beteckning}}
      </div>
    </div>
  </div>
  <div class="flex">
    <table class="map-popup-table col-6">
      <tr>
        <td class="map-popup-table-header" translate="PLANERA_POPUP_VOLYM"></td>
      </tr>
      <tr>
        <td>
          {{atgard.volymAtgard | number}} {{ 'PLANERA_ARBETSORDER_HEADER_M3FUB' | translate}}
        </td>
      </tr>
    </table>
    <table class="map-popup-table col-6">
      <tr>
        <td class="map-popup-table-header"
        translate="PLANERA_ARBETSORDER_DETAIL_INFO_TAB_SAMMANFATTNING_LABEL_SKORDAD"></td>
      </tr>
      @for (koppling of kopplingar; track koppling) {
        <tr>
          <td>{{ koppling['arbetsorderSkordningAvslutadDatum']| date: 'yyyy-MM-dd' }}</td>
        </tr>
      }
    </table>
  </div>
  @if (showAndelData) {
    <div class="grot-atgard-table">
      <div class="row mx-0">
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_TALL"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_GRAN"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_LOV"></div>
        <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_CONTORTA"></div>
      </div>
      <div class="row mx-0">
        <div class="col p-0">{{atgard.andelTall | raskFordelning}}</div>
        <div class="col p-0">{{atgard.andelGran | raskFordelning}}</div>
        <div class="col p-0">{{atgard.andelLov | raskFordelning}}</div>
        <div class="col p-0">{{atgard.andelContorta | raskFordelning}}</div>
      </div>
    </div>
  }
  <div class="row">
    <div class="col" class="map-popup-table-header" translate="PLANERA_POPUP_ATGARDSTYP"></div>
  </div>
  <div class="row">
    <div class="col">
      {{atgard.atgardstyp}}
    </div>
  </div>
  <div class="flex">
    <table class="map-popup-table col-6">
      <tr>
        <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG"></td>
        <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_BILVAG"></td>
      </tr>
      <tr>
        <td>{{ atgard.tillganglighetMark }}</td>
        <td>{{ atgard.tillganglighetVag }}</td>
      </tr>
    </table>
    <table class="map-popup-table col-6">
      <tr>
        <td class="map-popup-table-header" translate="PLANERA_POPUP_PLANERADSKOTNING"></td>
      </tr>
      @for (operation of operationer; track operation) {
        <tr>
          <td>{{ operation.startdatum| date: 'MMMM yyyy' }}</td>
        </tr>
      }
      @if (!(operationer?.length > 0)) {
        <tr>
          <td></td>
        </tr>
      }
    </table>
  </div>
  @if (isAtgardAddable === true) {
    <rask-button
      class="map-popup-add-button"
      color="primary"
    (click)="addAtgardToArbetsorder()">Lägg till</rask-button>
  }
}
